<div *ngIf="isLoading">Loading Status List...</div>

<select *ngIf="!isLoading" (change)="optionChanged.emit(true)" [compareWith]="byId" class="form-control" name="status"
        [(ngModel)]="model.status" [required]="required">
  <option *ngFor="let singleStatus of statuses" [ngValue]="singleStatus">{{ singleStatus.name }}</option>
</select>
